import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getContacts, getTelsAndEmails, sendEmail } from './actions';
import api from '../../services/api';

function* getContactsSaga(action: ReturnType<typeof getContacts.request>) {
  try {
    const contacts = yield call(api.getContacts, action.payload.cpf);
    yield put(getContacts.success(contacts));
  } catch {
    yield put(getContacts.failure('Falha ao buscar contatos.'));
  }
}

function* getTelsAndEmailsSaga(
  action: ReturnType<typeof getTelsAndEmails.request>
) {
  try {
    const telsAndEmails = yield call(api.getTelsAndEmails, action.payload.cpf);
    yield put(getTelsAndEmails.success(telsAndEmails));
  } catch {
    yield put(getTelsAndEmails.failure('Falha ao buscar contatos.'));
  }
}

function* sendEmailSaga(action: ReturnType<typeof sendEmail.request>) {
  try {
    const sent: string = yield call(api.sendEmail, action.payload);
    yield put(sendEmail.success(sent));
  } catch {
    yield put(sendEmail.failure('Falha ao enviar e-mail.'));
  }
}

export default all([
  takeLatest(getContacts.request, getContactsSaga),
  takeLatest(getTelsAndEmails.request, getTelsAndEmailsSaga),
  takeLatest(sendEmail.request, sendEmailSaga),
]);
